// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"21cd18f8","455":"1f68036a","977":"a4beeae6"}[chunkId] + ".chunk.js";
};